import './404.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/Seo';
import { Button } from '../components/primitives';
import MainLayout from '../components/layout/MainLayout';

export default function NotFoundPage() {
    const { t } = useTranslation('pages');
    return (
        <MainLayout>
            <SEO title='Page Not Found | Century Heating' />

            <div className='container not-found'>
                <h1>{t('not-found')}</h1>
                <p>{t('no-route-message')}</p>
                <Button link='/'>{t('return-home-message')}</Button>
            </div>
        </MainLayout>
    );
}
